// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"aE","arrowBtnBox":"aE","arrow-btn-wrap-box":"aF","arrowBtnWrapBox":"aF","arrow-btn-text":"aG","arrowBtnText":"aG","arrow-btn-arrow":"aH","arrowBtnArrow":"aH"};